import { createRouter, createWebHistory } from 'vue-router'
import { ref } from 'vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import StartView from '@/views/new/StartView.vue';
import ProductsView from '@/views/new/ProductsView.vue';
import ProductDetailsView from '@/views/new/ProductDetailsView.vue';
import SummaryView from '@/views/new/SummaryView.vue';
import PaymentView from '@/views/new/PaymentView.vue';
import PaymentCompleteView from '@/views/new/PaymentCompleteView.vue';
import EndView from '@/views/new/EndView.vue';
import UnavailableView from '@/views/new/UnavailableView.vue';
import ThemeView from '@/views/new/ThemeView.vue';
import HeaderView from '@/views/new/HeaderView.vue';
import PaymentFailedView from '@/views/new/PaymentFailedView.vue';
import CancelOrderView from '@/views/new/CancelOrderView.vue';
import AllergensView from '@/views/new/AllergensView.vue';
import ServiceView from '@/views/new/ServiceView.vue';
import PaperoutView from '@/views/new/PaperoutView.vue';
import i18n from '@/i18n';

export const navigationDirection = ref('forward');

const routes = [
    {
        path: '/:kioskId',
        component: DefaultLayout,
        children: [
            { path: '', name: 'Start', component: StartView },
            { path: 'service', name: 'Service', component: ServiceView },
            { path: 'paperout', name: 'Paperout', component: PaperoutView },
            { path: 'products', name: 'Products', component: ProductsView },
            { path: 'product', name: 'ProductDetails', component: ProductDetailsView },
            { path: 'summary', name: 'Summary', component: SummaryView },
            { path: 'cancel-order', name: 'CancelOrder', component: CancelOrderView },
            { path: 'payment', name: 'Payment', component: PaymentView },
            { path: 'payment-complete', name: 'PaymentComplete', component: PaymentCompleteView },
            { path: 'payment-failed', name: 'PaymentFailed', component: PaymentFailedView },
            { path: 'end', name: 'End', component: EndView },
            { path: 'unavailable', name: 'Unavailable', component: UnavailableView },
            { path: 'theme', name: 'Theme', component: ThemeView },
            { path: 'allergens', name: 'Allergens', component: AllergensView },
            { path: 'header', name: 'Header', component: HeaderView },
        ],
    }
];

const router = createRouter({
    history: createWebHistory('/kiosk'),
    routes
});

let isAlreadyAnimated = false;

router.beforeEach((to, from, next) => {
    const lang = to.query.lang || 'en';
    const noTransition = to.query.noTransition === '1';

    if (i18n.global.locale !== lang) {
        i18n.global.locale = lang;
    }

    const fromPath = from.fullPath.replace(/(\?|&)lang=[^&]*/g, '');
    const toPath = to.fullPath.replace(/(\?|&)lang=[^&]*/g, '');

    if ((from.params.kioskId === to.params.kioskId && fromPath === toPath && !isAlreadyAnimated) || (noTransition && !isAlreadyAnimated)) {
        isAlreadyAnimated = true;
        navigationDirection.value = 'none';
        return next();
    }

    const toIndex = Number(sessionStorage.getItem(to.fullPath));
    const fromIndex = Number(sessionStorage.getItem(from.fullPath));
    const historyCount = Number(sessionStorage.getItem('history-count') || '0');

    if (toIndex) {
        navigationDirection.value = toIndex < fromIndex ? 'backward' : 'forward';
    } else {
        const newIndex = historyCount + 1;
        sessionStorage.setItem('history-count', String(newIndex));
        sessionStorage.setItem(to.fullPath, String(newIndex));
        navigationDirection.value = 'forward';
    }

    next();
});

router.afterEach((to) => {
    if (to.query.noTransition === '1') {
        const { noTransition, ...query } = to.query;
        console.log(noTransition);
        router.replace({ path: to.path, query });
    }
});

export default router;
